var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureDataExtraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.155,
    height: 211.953,
    viewBox: "0 0 177.155 211.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132",
    transform: "translate(-1146.845 -797.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-bulb_64x64",
    "data-name": "streamline-icon-bulb@64x64",
    transform: "translate(1262 945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_726",
    "data-name": "Path 726",
    d: "M40,46v6a4,4,0,0,1-4,4H28a4,4,0,0,1-4-4V46",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_727",
    "data-name": "Path 727",
    d: "M32,2V6",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_728",
    "data-name": "Path 728",
    d: "M4,30H8",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_729",
    "data-name": "Path 729",
    d: "M10,10l2.933,2.819",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_730",
    "data-name": "Path 730",
    d: "M60,30H56",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_731",
    "data-name": "Path 731",
    d: "M54,10l-2.933,2.819",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_732",
    "data-name": "Path 732",
    d: "M23.773,46H40.227A17.6,17.6,0,0,0,50,30,18.328,18.328,0,0,0,32,12,18.328,18.328,0,0,0,14,30.011,17.6,17.6,0,0,0,23.773,46Z",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_733",
    "data-name": "Path 733",
    d: "M32,56v6",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_734",
    "data-name": "Path 734",
    d: "M32,36V46",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_735",
    "data-name": "Path 735",
    d: "M26,30l6,6,6-6",
    fill: "none",
    stroke: "#00b7bc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-filter-text_64x64",
    "data-name": "streamline-icon-filter-text@64x64",
    transform: "translate(1146.91 797.047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_736",
    "data-name": "Path 736",
    d: "M37.992,14h20a4,4,0,0,1,4,4V58a4,4,0,0,1-4,4h-36a4,4,0,0,1-4-4V42",
    fill: "none",
    stroke: "#d644a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M33.992,26H54",
    fill: "none",
    stroke: "#d644a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M27.992,38H54",
    fill: "none",
    stroke: "#d644a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M28,50H54",
    fill: "none",
    stroke: "#d644a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M22,26V18L33.171,6.829a2.829,2.829,0,0,0-2-4.829H4.829a2.829,2.829,0,0,0-2,4.829L14,18V34Z",
    fill: "none",
    stroke: "#d644a0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M18025.777,877.768v-18.3h144.631V840.8",
    transform: "translate(377.596 19002.777) rotate(-90)",
    fill: "none",
    stroke: "#c4c4c4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureDataExtraction);
export default __webpack_public_path__ + "static/media/feature-data-extraction.fe0dbaea.svg";
export { ForwardRef as ReactComponent };